/**
 * anchor.js
 *
 * Javascript for the anchor scrolling
 *
 * @package Wordpress/imhof-digital
 * @since   5.6.0
 * @author  Imhof Digital <info@imhof-digital.de>
 */

jQuery( document ).ready( function( $ ) {
   // declare strict mode
   'use strict';

   /**
    * anchorScrolling OBJECT
    *
    * @since      5.6.0
    * @property   array anchors  Array of anchor-links of the page
    * @method     clickHandler() Processes the clicks on anchor-links
    * @method     init()         Initiates the anchor-scrolling-function
    */
   idscript.anchorScrolling = {

      /**
       * @var     array    anchors     Array of anchor-links of the page
       *
       * @since   5.6.0
       * @usedby  method   self::init()
       */
      anchors: $( 'a.scroll-to-anchor' ),

      /**
       * clickHandler()
       *
       * Processes the clicks on anchor-links
       *
       * @since   5.6.0
       * @usedby  method   self::init()
       */
      clickHandler: function( e ) {
         //cross-browser capture of event-Object
         event = ( event ) ? event : window.event;
         event.preventDefault();
         //define the scroll target
         var target = e.currentTarget.hash;
         var targetPosition = $( "a[name='"+target.replace( '#', '' )+"']" )[ 0 ].offsetTop || 0;
         //animate the scrolling
         $('html, body').animate({
            scrollTop: ( targetPosition - 108 )
         }, 1000 );

         return false;
      },

      /**
       * init()
       *
       * Initiates the anchor-scrolling-function
       *
       * @since   5.6.0
       * @uses    property self::anchors
       * @uses    method   self::clickHandler()
       */
      init : function() {
         $( idscript.anchorScrolling.anchors ).each( function( index, element ) {
            $( element ).on( 'click', idscript.anchorScrolling.clickHandler );
         } );
         return;
      }
   };
   idscript.anchorScrolling.init();
});
